import { render, staticRenderFns } from "./demo-order-confirmation-flow.vue?vue&type=template&id=060e4e14&scoped=true&"
import script from "./demo-order-confirmation-flow.vue?vue&type=script&lang=js&"
export * from "./demo-order-confirmation-flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e4e14",
  null
  
)

export default component.exports